import { useCallback } from 'react';
import { useCustomersOverviews } from '../../../../hooks/requests/use-customers-overviews/use-customers-overviews';
import { useVyNavigate } from '../../../../hooks/use-vy-navigate';
import { PLAN_CREATE_ROUTE } from '../../../../router/routing-consts';
import { CreateContractForm } from '../components/CreateContractForm';
import { useCreateContractForm } from '../hooks/use-create-contract-form';
import type { AssignCustomerForm } from '../types/assign-customer-dialog-form-types/assign-customer-form-schema';
import { isNotNullOrUndefined, isNullOrUndefined } from '@vy/utils';
import { CREATE_PLAN_QUERY_PARAMS } from '../../CreatePlanPage/create-plan-page-consts/query-params';
import { useLocation } from 'react-router-dom';

type CreateContractFormContainerProps = {
  isOpen: boolean;
  onClose: () => void;
  initialCustomerId?: string;
  cloneFromPlanId?: string;
  label: string;
  labelDescription: string;
};

export const CreateContractFormContainer: React.FC<CreateContractFormContainerProps> = ({
  isOpen,
  onClose,
  initialCustomerId,
  cloneFromPlanId,
  label,
  labelDescription,
}) => {
  const location = useLocation();
  const navigate = useVyNavigate();
  const form = useCreateContractForm(initialCustomerId, isNotNullOrUndefined(cloneFromPlanId));
  const { data: customerOverviewResponse } = useCustomersOverviews();
  const { customers = [] } = customerOverviewResponse ?? {};

  const handleSubmit = form.handleSubmit((data: AssignCustomerForm) => {
    const createPlanPath = buildCreatePlanPath(cloneFromPlanId);

    navigate(createPlanPath, {
      state: {
        customerId: data.customerId,
        startDate: data.startDate,
        contractType: data.contractType,
        from: location.pathname,
      },
    });
  });

  const handleClose = useCallback(() => {
    onClose();
    form.reset();
  }, [onClose, form]);

  return (
    <CreateContractForm
      form={form}
      customers={customers}
      onSubmit={handleSubmit}
      onClose={handleClose}
      isOpen={isOpen}
      label={label}
      labelDescription={labelDescription}
    />
  );
};

function buildCreatePlanPath(cloneFromPlanId?: string) {
  return `${PLAN_CREATE_ROUTE}${createQueryParam(CREATE_PLAN_QUERY_PARAMS.CLONE_FROM_PLAN_ID, cloneFromPlanId)}`;
}

function createQueryParam(paramName: string, paramValue?: string) {
  if (isNullOrUndefined(paramValue)) {
    return '';
  }

  return `?${paramName}=${paramValue}`;
}
